import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ba318e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row" }
const _hoisted_2 = { class: "flex-fill d-flex flex-row justify-content-between justify-content-lg-start align-items-center flex-wrap" }
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  class: "slider-container order-2 order-lg-1 flex-fill w-100 w-lg-auto",
  ref: "slider"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-bar" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider-range-bar" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-toggle left" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slider-toggle right" }, null, -1))
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-ban" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "time",
        value: _ctx.start,
        class: "mr-3 order-0 order-lg-0 flex-lg-0",
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeStart && _ctx.changeStart(...args)))
      }, null, 40, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _hoisted_9, 512),
      _createElementVNode("input", {
        type: "time",
        value: _ctx.end,
        class: "ml-3 order-1 order-lg-2 flex-lg-0",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeEnd && _ctx.changeEnd(...args)))
      }, null, 40, _hoisted_10)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-secondary btn-sm ml-3",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetToggles && _ctx.resetToggles(...args)))
    }, _hoisted_12)
  ]))
}